import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import LinearProgress from '@mui/material/LinearProgress';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { CreateReconsignmentContext, setup } from './Create';

const Titlebar = ({ bulk, onClose, progress, step, title, totalSteps }) => {
  const { info, setOpenDialog, setIsNavHidden } = useContext(CreateReconsignmentContext);
  const navigate = useNavigate();

  const handleClose = event => {
    const changeProps = R.pick(['destinations', 'isRecurring', 'product', 'rvp']);
    const contextProps = changeProps(info);
    const initialProps = changeProps(setup);
    const hasChanges = !R.equals(initialProps, contextProps);

    onClose(event, hasChanges, setOpenDialog);

    if (!event.isDefaultPrevented()) {
      if (!bulk && hasChanges) {
        setOpenDialog(true);
      } else {
        setOpenDialog(false);
        navigate('../../');
        setIsNavHidden(false);
      }
    }
  };

  return (
    <AppBar
      elevation={1}
      sx={{
        alignItems: 'center',
        backgroundColor: 'surface.white',
        flexDirection: 'row',
        height: '100px',
        justifyContent: 'space-between',
        px: 3,
        py: 3,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          textAlign: 'left',
        }}
      >
        <Typography
          noWrap
          sx={{
            alignSelf: 'flex-start',
            border: 'none',
            fontSize: '1.4rem',
            mb: 0.5,
            mt: 0.5,
            textAlign: 'left',
            textOverflow: 'ellipsis',
          }}
          variant="h6"
        >
          {title}
        </Typography>
        {progress && (
          <LinearProgress
            data-variant="magellanProgressBar"
            sx={{
              alignSelf: 'flex-start',
              m: (0.5, 0),
              mt: 2.5,
              textAlign: 'left',
              width: '100%',
            }}
            value={progress}
            variant="determinate"
          />
        )}
        {step && totalSteps && (
          <Typography
            sx={{
              mb: 1,
              mt: 2.5,
              py: 1,
              textAlign: 'left',
            }}
            variant="caption"
          >
            Details ({step} of {totalSteps})
          </Typography>
        )}
      </div>
      <IconButton
        onClick={handleClose}
        size="large"
        sx={{
          color: 'graphic.icons',
        }}
      >
        <CloseRoundedIcon />
      </IconButton>
    </AppBar>
  );
};

Titlebar.propTypes = {
  bulk: PropTypes.bool,
  onClose: PropTypes.func,
  progress: PropTypes.number,
  step: PropTypes.number,
  title: PropTypes.string,
  totalSteps: PropTypes.number,
};

Titlebar.defaultProps = {
  bulk: false,
  onClose: () => {},
  progress: null,
  step: null,
  title: 'Create New Reconsignment',
  totalSteps: null,
};

export default Titlebar;
